import React, { useContext } from "react";
import FavoriteContext from "../contexts/favoriteContext";

const Pokemon = (props) => {
  const { pokemon } = props;
  const { favoritePokemons, updateFavoritePokemons } = useContext(
    FavoriteContext
  );

  const blackHeart = "🖤";
  const redHeart = "❤️";
  const heart = favoritePokemons.includes(pokemon.name) ? redHeart : blackHeart;

  const clickHeart = (e) => {
    updateFavoritePokemons(pokemon.name);
  };

  return (
    <div className="pokemon-card">
      <div className="pokemon-img-container">
        <img
          className="pokemon-img"
          alt={pokemon.name}
          src={pokemon.sprites.front_default}
        />
      </div>
      <div className="card-body">
        <div className="card-top">
          <h3>{pokemon.name}</h3>
          <div># {pokemon.id}</div>
        </div>
        <div className="card-bottom">
          <div className="pokemon-type">
            {pokemon.types.map((type, idx) => {
              return (
                <div key={idx} className="pokemon-type-text">
                  {type.type.name === "grass" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "lightgreen",
                        border: "2px solid green",
                        color: "green",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "water" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "lightblue",
                        border: "1px solid blue",
                        color: "blue",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "fire" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "rgba(255, 0, 0, 0.19)",
                        border: "2px solid #FF0000",
                        color: "red",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "bug" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#9BEF00",
                        border: "2px solid #669900",
                        color: "#669900",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "poison" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#e066ff",
                        border: "2px solid purple",
                        color: "purple",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "normal" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#7777",
                        border: "2px solid black",
                        color: "black",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "electric" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "lightyellow",
                        border: "2px solid #ffcc00",
                        color: "#ffcc00",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "flying" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "rgba(79, 50, 255, 0.1)",
                        border: "2px solid #4F32FF",
                        color: "blue",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "ground" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#cc9966",
                        border: "2px solid #604020",
                        color: "#604020",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "fairy" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#ffb3ff",
                        border: "2px solid #ff00ff",
                        color: "#ff00ff",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "fighting" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#ff9999",
                        border: "2px solid #cc0000",
                        color: "#cc0000",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "psychic" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#ff99e6",
                        border: "2px solid #cc0099",
                        color: "#cc0099",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "rock" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#ffdab3",
                        border: "2px solid #4d2800",
                        color: "#4d2800",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "steel" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#e0e0eb",
                        border: "2px solid #32324e",
                        color: "#32324e",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "ghost" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#cc99ff",
                        border: "2px solid ##440066",
                        color: "#440066",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "ice" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#b3d9ff",
                        border: "2px solid #0080ff",
                        color: "#0080ff",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : type.type.name === "dragon" ? (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#b380ff",
                        border: "2px solid #6600ff",
                        color: "#6600ff",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  ) : (
                    <div
                      key={idx}
                      className="pokemon-type-text"
                      style={{
                        background: "#e1e1d0",
                        border: "2px solid #2f2f1e",
                        color: "#2f2f1e",
                        padding: "5px",
                        borderRadius: "10px"
                      }}
                    >
                      {type.type.name}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <button onClick={clickHeart}>
            <div className="pokemon-fav">
              <span role="img" aria-label="fav">
                {heart}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pokemon;
